import { BaseModel } from '../base.model';

export class EmployeeDesignationDto extends BaseModel {
  public name: string;
  public employeeDesignationId: number;

  constructor(o: any = null) {
    super(o);
  }
}
